module.exports = __webpack_public_path__ + "img/研学营.7686d47f.png";